import { render, staticRenderFns } from "./AbkCvEducationFormSection.vue?vue&type=template&id=da52184e&scoped=true&"
import script from "./AbkCvEducationFormSection.vue?vue&type=script&lang=js&"
export * from "./AbkCvEducationFormSection.vue?vue&type=script&lang=js&"
import style0 from "./AbkCvEducationFormSection.vue?vue&type=style&index=0&id=da52184e&lang=scss&scoped=true&"
import style1 from "./AbkCvEducationFormSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da52184e",
  null
  
)

export default component.exports